import tv from "../assets/smart-tv.png";
import blueRay from "../assets/bluray.png";
import game from "../assets/console.png";
import vid from "../assets/video-tutorial.png";
import smartPhone from "../assets/smartphone.png";
export const way = [
  {
    img: tv,
    heading: "Streaming Media Players",
    alt: "tv",
  },

  {
    img: game,
    heading: "Game console",
    alt: "game console",
  },
  {
    img: blueRay,
    heading: "Blue ray Players",
    alt: "blue ray player",
  },
  {
    img: vid,
    heading: "Smart TVs",
    alt: "tv",
  },
  {
    img: smartPhone,
    heading: "Smart phone",
    alt: "tv",
  },
];
